const revealSousTraitants = () => {
  const revealButtons = document.querySelectorAll('.reveal-st');
  revealButtons.forEach(button => button.addEventListener('click', (event) => {
    const sousTraitants = event.target.nextElementSibling;
    console.log(sousTraitants)
    const hiddenSousTraitants = sousTraitants.querySelector('.hidden_sous_traitant');
    sousTraitants.classList.toggle('d-none');
    // hiddenSousTraitants.classList.remove('d-none');
  }));
}

const updateInterInputs = () => {
  const addButtons = document.querySelectorAll('.add_fields.add-new-inter');

  if (addButtons.length > 0) {
    addButtons.forEach(button => button.addEventListener('click', (event) => {
      const container = event.target.parentElement;
      const modeOperatoireId = container.dataset.mo;
      const enterpriseId = container.dataset.enterprise;


      setTimeout(() => {

        const intervenants = container.parentElement.querySelectorAll('.intervenant-fields.nested-fields');
        intervenants.forEach(inter => {
          // const counter = inter.dataset.counter;
          const enterpriseInput = inter.querySelector('.enterprise-id');
          enterpriseInput.value = enterpriseId;

          const modeOpInput = inter.querySelector('.mode-op-id');
          modeOpInput.value = modeOperatoireId;
        })
      }, 50)
    }));
  }
}

const signatureIntervenants = () => {
  revealSousTraitants();
  updateInterInputs();
}

export default signatureIntervenants;
